import { timelineEntries } from "@/mocks/home";
import Reveal from "./Reveal";

export default function ArchiveTimeline() {
  return (
    <section id="timeline" className="bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 border-b border-background-200 pb-6">
          <div>
            <span className="text-xs tracking-[0.3em] text-secondary-500 uppercase">Timeline</span>
            <h2 className="mt-2 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              归档时间线
            </h2>
            <p className="mt-3 max-w-2xl text-sm md:text-base leading-7 text-foreground-700">
              黑料在线历史记录按时间先后排好，每条都是「标题 + 短摘要」的结构，先看结论再决定要不要往下翻。
            </p>
          </div>
          <a
            href="#index"
            className="inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 whitespace-nowrap cursor-pointer"
          >
            查看全部记录
            <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="mt-8 flex flex-col">
          {timelineEntries.map((entry, index) => (
            <Reveal
              key={entry.id}
              delay={index * 60}
              className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-6 py-6 md:py-7 border-b border-background-100"
            >
              <div className="md:col-span-2 flex md:flex-col items-center md:items-start gap-3">
                <span className="font-heading text-sm md:text-base font-semibold text-foreground-900">
                  {entry.date}
                </span>
                <span className="text-[11px] text-foreground-500 whitespace-nowrap">
                  {entry.tag}
                </span>
              </div>

              <a
                href="#timeline"
                className="md:col-span-7 group flex gap-4 cursor-pointer"
              >
                <div className="w-28 h-24 md:w-40 md:h-28 shrink-0 rounded-md overflow-hidden border border-background-200">
                  <img
                    src={entry.image}
                    alt={entry.title}
                    title={`${entry.title} - 黑料在线历史记录`}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="flex flex-col">
                  <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors leading-7">
                    {entry.title}
                  </h3>
                  <p className="mt-2 text-xs md:text-sm leading-6 text-foreground-600 line-clamp-2">
                    {entry.summary}
                  </p>
                </div>
              </a>

              <div className="md:col-span-3 flex md:flex-col md:items-end gap-4 md:gap-2 text-xs text-foreground-500">
                <span className="inline-flex items-center gap-1.5">
                  <i className="ri-time-line" />
                  {entry.readTime}
                </span>
                <span className="inline-flex items-center gap-1.5">
                  <i className="ri-chat-3-line" />
                  {entry.comments} 条讨论
                </span>
                <span className="hidden md:inline-flex items-center gap-1.5 text-primary-600 hover:text-primary-700 cursor-pointer">
                  进入回看
                  <i className="ri-arrow-right-up-line" />
                </span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}